import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageUnion } from '@airgram/web';
import { TelegramMessengerService } from '@src/app/modules/telegram';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'telegram-pinned-message-list',
  templateUrl: './pinned-message-list.component.html',
  styleUrls: ['./pinned-message-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PinnedMessageListComponent extends BaseResizableComponent implements OnChanges {
  private readonly messengerService = inject(TelegramMessengerService);

  @Input() chatId?: number;
  @Output() scrollToMessageId = new EventEmitter<number>();

  pinnedMessages?: MessageUnion[];
  visibledIndex: number = 0;

  override ngOnInit(): void {
    super.ngOnInit();

    this.messengerService.updates$.pipe(takeUntil(this.destroyed$$)).subscribe(update => {
      switch (update._) {
        case 'updateMessageIsPinned':
          this.loadPinnedMessages();
          break;

        default:
          break;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chatId) {
      this.loadPinnedMessages();
    }
    this.cdr.markForCheck();
  }

  scrollToMessage(messageId: number): void {
    this.nextVisibledIndex();
    this.scrollToMessageId.emit(messageId);
  }

  private loadPinnedMessages() {
    this.pinnedMessages = [];
    if (this.chatId) {
      this.messengerService.api.loadPinnedMessages(this.chatId).then(pinnedMessages => {
        this.pinnedMessages = pinnedMessages.messages;
        this.visibledIndex = 0;
        this.cdr.markForCheck();
      });
    }
  }

  private nextVisibledIndex() {
    this.visibledIndex++;
    if (!this.pinnedMessages || this.visibledIndex >= this.pinnedMessages.length) {
      this.visibledIndex = 0;
    }
  }
}
